/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponsePagedResultAiMessageSuggestion } from '../models/api-response-paged-result-ai-message-suggestion';
import { searchAiSuggestions } from '../fn/ai-message-suggestion-api/search-ai-suggestions';
import { SearchAiSuggestions$Params } from '../fn/ai-message-suggestion-api/search-ai-suggestions';

@Injectable({ providedIn: 'root' })
export class AiMessageSuggestionApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchAiSuggestions()` */
  static readonly SearchAiSuggestionsPath = '/v1/api/ui/ai-message-suggestion/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAiSuggestions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAiSuggestions$Response(params: SearchAiSuggestions$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAiMessageSuggestion>> {
    return searchAiSuggestions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAiSuggestions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAiSuggestions(params: SearchAiSuggestions$Params, context?: HttpContext): Observable<ApiResponsePagedResultAiMessageSuggestion> {
    return this.searchAiSuggestions$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAiMessageSuggestion>): ApiResponsePagedResultAiMessageSuggestion => r.body)
    );
  }

}
